import { Checkbox } from "@pacificoseguros/pixie/react/checkbox";
import React, { useCallback } from "react";
import { Row } from "../../../components/layout/flex-layout";
import { Typography } from "../../../components/typography/typography";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import { useQuotationPopupFormContext } from "../hooks/use-quotation-popup-form";

export const QuotationPopupValidAgeCheckboxField: React.FC = () => {
    const rhForm = useQuotationPopupFormContext();
    const { employeesHaveValidAge } = rhForm.watch([
        quotationPopupFormDefinition.employeesHaveValidAge.key,
    ]);
    const handleChange = useCallback((value) => {
        rhForm.setValue("employeesHaveValidAge", value.detail, {
            shouldValidate: true,
        });
    }, []);
    return (
        <Row
            align="flex-start"
            data-testid="QuotationPopupValidAgeCheckboxField"
        >
            <Checkbox
                checked={employeesHaveValidAge}
                handleChange={handleChange}
            >
                <span></span>
            </Checkbox>
            <Typography variant="grey-1">
                Declaro que todos mis trabajadores tienen entre 18 a 60 años y
                que mi negocio o empresa no pertenece al sector público o pesca.
            </Typography>
        </Row>
    );
};
